import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '@/lib/api';
import { Gem, ChevronRight } from 'lucide-react';

/**
 * RedBerylReadinessTile — live go-live checklist for the RedBeryl client.
 * Items flip green as Dipali hands over each piece (dept ID, contact
 * identity, roster…). Links to the import screen. Hides itself once
 * everything is green for 0 pending? No — CEO wants to watch it, keep it.
 */
export default function RedBerylReadinessTile({ className = '' }) {
  const [data, setData] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/redberyl/readiness').then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data) return null;
  const done = data.checklist.filter((c) => c.ready).length;

  return (
    <div
      className={`rounded-xl border border-[#e6d9d9] bg-white p-5 ${className}`}
      data-testid="redberyl-readiness-tile"
    >
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <Gem size={18} color="#8B1A1A" />
          <span className="font-semibold text-[15px]" style={{ color: '#8B1A1A' }}>
            RedBeryl · Go-Live Readiness
          </span>
          <span
            className={`text-[11px] px-2 py-0.5 rounded-full font-semibold ${
              data.ready_for_golive
                ? 'bg-[#ecfdf5] text-[#065f46]'
                : 'bg-[#fef3c7] text-[#92400e]'
            }`}
            data-testid="redberyl-readiness-badge"
          >
            {done}/{data.checklist.length} ready
          </span>
        </div>
        <button
          onClick={() => navigate('/redberyl/import')}
          className="text-[12px] font-semibold flex items-center gap-0.5 hover:underline"
          style={{ color: '#8B1A1A' }}
          data-testid="redberyl-readiness-import-link"
        >
          Import roster <ChevronRight size={14} />
        </button>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1.5">
        {data.checklist.map((c) => (
          <div key={c.item} className="flex items-start gap-2 text-[13px]">
            <span
              className="mt-1 h-2.5 w-2.5 rounded-full flex-shrink-0"
              style={{ background: c.ready ? '#2D8B5E' : '#C98A1F' }}
            />
            <div>
              <span className={c.ready ? 'text-[#1B2A4A]' : 'text-[#92400e]'}>
                {c.item}
              </span>
              <span className="text-[#9CA3AF] ml-1.5 text-[12px]">
                {Array.isArray(c.value) ? c.value.join(', ') : c.value}
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
